// import OnboardingWalkmeWelcome from '../../assets/OnboardingWalkmeWelcome.svg'
import Walkme_Guide from '../../assets/Walkme_Guide.svg'
import OnboardingMiniImg from '../../assets/OnboardingMiniImg.svg'

export const TOUR_STEPS = [
  {
  target: 'html',
  placement: 'center',
  disableBeacon: true,
    // route: '/home',
  disableOutsideClick: true,
  disableOverlayClose: true,
  spotlightClicks: false,
  content: (
    <div className="welcome-step">
      <div className="welcome-left">
        <img
          // src="../routes/OnboardingWalkmeWelcome.svg"  // put your image in public folder
          src={Walkme_Guide}  // put your image in public folder
          alt="Welcome"
        />
      </div>

      <div className="welcome-right">
        <div style={{marginBottom: '1rem'}}><img src={OnboardingMiniImg} alt="" /></div>
        <div className='onboarding-welcome'>Welcome to the Procurement Hub guided tour</div>

        <p className='onboarding-subtext-welcome'>
          Let's take this brief tour before you get started. Click on the rocket icon next to your profile to retake the tour anytime. 🚀
        </p>
      </div>
    </div>
  )
  },
  {
    target: '.sidebar-content > :nth-child(2)',
    content: (
      <>
      <div className='walkme-step-title'>Landing Page for All Procurement Apps</div>
      <br/>
        <div className='walkme-step-content'>
          No need to log in multiple times. Access all apps through one seamless gateway.
        </div>
      </>
      ),
    route: '/home',
    disableBeacon: true,
    disableOutsideClick: true,
    styles: {
      spotlight: {
        transform: 'translateX(-10px)',
      },
    },
  className: 'walkme-common-steps'
  },

  {
    target: '.static-kpi-card .market-card',
    placement: 'auto',
     disableOutsideClick: true,
    // spotlightPadding: {
    //       top: 0,
    //       bottom: 60,
    //       left: 0,
    //       right: 0
    // },
    // spotlightPadding: 30,
    content: (
      <>
      <div className='walkme-step-title'>Additional Apps Available</div>
      <br/>
        <div className='walkme-step-content'>
          Certain capability cards include multiple applications. Select the arrow to expand the card and access the full list.
        </div>
      </>
      ),
    route: '/home',
    styles: {
      // spotlight: {
      //   transform: 'translateY(20px)',
      // },
      spotlight: {
        transform: 'scaleY(1.3) translateY(20px)', 
        borderRadius: 12
      },
      // tooltip: {
      //   width: "400px"   // fixed width
      // }
    },  
    // disableBeacon: true,
    autoOpenKpiButton: true,
    className: 'walkme-common-steps'
  },

  {
    target: '.sidebar-content > :nth-child(3)',
    offset: 20,   // 👈 pushes tooltip slightly away
     disableOutsideClick: true,
    placement: 'auto',
    content: (
      <>
      <div className='walkme-step-title'>Your personalized Category 360º view</div>
      <br/>
        <div className='walkme-step-content'>
          See all key KPIs across your region and category in one click.
        </div>
      </>
      ),
    // content: 'See all key KPIs across your region and category in one click.',
    route: '/overview',
    styles: {
      spotlight: {
        transform: 'translateX(-10px)',
      },
      // tooltip: {
      //   width: "400px"   // fixed width
      // }
    },
    disableBeacon: true,
    className: 'walkme-common-steps'
  },
  
  //  {
  //   target: '.profile-dropdown .profile-menu .list-v2 > :nth-child(3)',
  //   placement: 'left',
  //   content: (
  //     <>
  //     <div className='walkme-step-title'>Your Data Is Persona-Based</div>
  //     <br/>
  //       <div className='walkme-step-content'>
  //         Your view is customized using your user persona. If something looks off, create or update your persona to get the most relevant data.
  //       </div>
  //     </>
  //     ),
  //   route: '/overview',
  //   disableBeacon: true,
  //   autoOpenProfileSection: true,
  //   disableOutsideClick: true,
  // },
  {
    target: '.custom-view-manager-button',
    placement: 'left',
    content: (
      <>
      <div className='walkme-step-title'>Set Up Your Custom View</div>
      <br/>
        <div className='walkme-step-content'>
          Click Custom View Manager to open the Microsoft Form. Select your sectors, business units, and procurement categories to personalize your Procurement Hub view.
        </div>
      </>
      ),
    route: '/overview',
    disableBeacon: true,
    // autoOpenProfileSection: true,
    disableOutsideClick: true,
  },
  {
    target: '.static-kpi-card .spend-card .kpi-card-header-icons',
    content: (
      <>
      <div className='walkme-step-title'>Dive into data</div>
      <br/>
        <div className='walkme-step-content'>
          Want more detail? Click on the chart button of the capability card to explore insights, charts, and download options.
        </div>
      </>
      ),
    // content: 'Want more detail? Click on the chart button of the capability card to explore insights, charts, and download options.',
    route: '/overview',
    highlightSpendCard: true,
    disableBeacon: true,
    disableOutsideClick: true,
    // className: 'walkme-common-steps',
    placement: "top",
    // isFixed: true,
    // floaterProps: {
    //   // offset: 10,
    //   flip: false
    // },

    disableOverlayClose: true,   // clicking outside does nothing
    spotlightClicks: false,      // clicking inside highlight does nothing
    disableCloseOnEsc: true      // optional safety
  },

  {
    target: '.spend-detailpage-kpi-section',
     disableOutsideClick: true,
    content: (
      <>
      <div className='walkme-step-title'>KPI Detailed page</div>
      <br/>
        <div className='walkme-step-content'>
          View all key metrics tailored to your prepopulated filters. Designed to provide quick, actionable insights for strategic decision-making
        </div>
      </>
      ),
    highlightKpiSection: true,
    route: '/overview',
    className: 'walkme-common-steps',
    
    isFixed: true,
    styles: {
    spotlight: {
      // transform: 'scale(0.8)',
      // transformOrigin: 'top left'
      transform: 'translateY(60%)',
      },
      // tooltip: {
      //   width: "400px"   // fixed width
      // }
    },
    disableBeacon: true,
    disableOverlayClose: true,   // clicking outside does nothing
    spotlightClicks: false,      // clicking inside highlight does nothing
    disableCloseOnEsc: true      // optional safety
  },
  {
  target: '.spend-download-btn-options',
  disableOutsideClick: true,
  content: (
      <>
      <div className='walkme-step-title'>KPI detailed page download functionality</div>
      <br/>
        <div className='walkme-step-content'>
          Click the download icon to export the selected KPI. Choose <b>PDF</b> to generate a detailed report or <b>JPEG</b> to save a visual image.
        </div>
      </>
  ),
  route: '/overview',
  placement: 'left',
  disableBeacon: true,
  autoOpenDownloadOptions: true,
  styles: {
    spotlight: {
      transform: 'translateY(150%)',
      },
    },
//   styles: {
//   spotlight: {
//     marginTop: '100px'
//   }
// }
  },
];
